import React, { useState } from 'react'
import { Card, Col, Flex, Form, Row, Typography } from 'antd'
import {ModuleTopHeading, Projecttable, SearchInput, Transactiontable } from '../../components';

const { Text } = Typography
const Transaction = () => {

    const [ visible, setVisible] = useState(false)
    const [ edititem, setEditItem ] = useState(null)
    const [form] = Form.useForm();
   
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Transaction History'/>
                            <Form
                                form={form}
                                layout="vertical"
                            >
                                <Row gutter={[16,16]} align={'middle'}>
                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <SearchInput 
                                            name='name'
                                            placeholder='Search Name'
                                            value={form.getFieldValue('name') || ''}
                                            prefix={<img src='/assets/icons/search.png' width={20} />}
                                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Flex>
                    </Col>
                    <Col span={24}>
                       <Transactiontable {...{setEditItem,setVisible}} />
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { Transaction }
